export default class EditBugModalController {
  constructor(Technology, Vendor) {
    'ngInject';

    this.Vendor = Vendor;
    this.Technology = Technology;
  }

  $onInit() {
    this.technologies = [];

    this.loadVendors();
    this.loadTechnologies();
  }

  loadTechnologies() {
    return this.Technology.query().$promise
      .then((response) => {
        this.technologies = response.technologies;
      })
  }

  loadVendors() {
    return this.Vendor.query().$promise
      .then((response) => {
        this.vendors = response.vendors;
      })
  }
}



// WEBPACK FOOTER //
// ./src/app/screens/engineer/screens/mysolvr-entries/components/edit-bug-modal/edit-bug-modal.controller.js